import api from '@/api';

const resource = 'gerencial/vincular-perfil';

export default {
  getSelectPerfil() {
    return api.get(`${resource}/select`);
  },
  getUsuarioPerfis(id) {
    return api.get(`${resource}/${id}/perfil`);
  },
  getUsuarioPerfil(id, idPerfil) {
    return api.get(`${resource}/${id}/perfil/${idPerfil}`);
  },
  postUsuarioPerfil(data) {
    return api.post(`${resource}/${data.identificadorusuario}`, data);
  },
  putUsuarioPerfil(data) {
    return api.put(`${resource}/${data.identificadorusuario}/perfil/${data.identificadorusuarioperfil}`, data);
  },
  deleteUsuarioPerfil(id, idPerfil) {
    return api.delete(`${resource}/${id}/perfil/${idPerfil}`);
  },
};